module.exports = __webpack_public_path__ + "img/sign.686839bd.png";